/**
 * Écart horizontal entre colonnes (jours) en vue mois.
 * Doit rester identique à $rbc-month-column-gap dans src/styles/tools/bigCalendar.scss.
 */
export const MONTH_COLUMN_GAP_PX = 10;

/**
 * Largeur flex d’un segment couvrant `len` créneaux consécutifs, avec le même gap que
 * `gap` / `column-gap` sur la ligne flex (7 colonnes, 6 interstices).
 */
export function monthRowSegmentFlexBasis(slots, len) {
  const n = Math.abs(len);
  if (n <= 0) return '0%';
  const g = MONTH_COLUMN_GAP_PX;
  const totalGapsPx = (slots - 1) * g;
  const innerGapsPx = (n - 1) * g;
  return `calc(${n} * (100% - ${totalGapsPx}px) / ${slots} + ${innerGapsPx}px)`;
}
